import postWithToken from './base/post-with-token'

const customerAddOrUpdateMeta = (id, type, data, action) => postWithToken(`/customer/${id}/trade-waste-meta-data?type=${type}&action=${action}`)(data)

export default customerAddOrUpdateMeta